<div class="modal-container">
  <!-- Sticky Header -->
  <div class="modal-header">
    <h2>Choose items to export</h2>
  </div>

  <!-- Content Area -->
  <div class="modal-content">
    <div class="content-split">
      <!-- Selection Section (50%) - LEFT -->
      <div class="selection-section">
        <div class="selection-header">
          <h3>
            @if (exportMode === 'messages') {
              Select Messages ({{ countSelectedItems() }} of
              {{ conversationService.currentValue?.messages?.length || 0 }} selected)
            }
            @if (exportMode === 'tables') {
              Select Tables ({{ countSelectedTables() }} of {{ tableItems.length }} selected)
            }
          </h3>
          <mat-button-toggle-group
            [(ngModel)]="exportMode"
            (change)="onExportModeChange()"
            class="export-mode-toggle"
          >
            <mat-button-toggle value="messages">Messages</mat-button-toggle>
            <mat-button-toggle value="tables">Tables</mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <div class="selection-controls">
          @if (exportMode === 'messages') {
            <button mat-button color="primary" (click)="toggleSelectAll()" class="select-all-btn">
              <mat-icon>{{ selectedAll ? 'deselect' : 'select_all' }}</mat-icon>
              {{ selectedAll ? 'Unselect all' : 'Select all' }}
            </button>
          }
          @if (exportMode === 'tables') {
            <button
              mat-button
              color="primary"
              (click)="toggleSelectAllTables()"
              class="select-all-btn"
            >
              <mat-icon>{{ selectedTablesAll ? 'deselect' : 'select_all' }}</mat-icon>
              {{ selectedTablesAll ? 'Unselect all' : 'Select all' }}
            </button>
          }
        </div>

        <div class="messages-list">
          @if (exportMode === 'messages') {
            @for (msg of conversationService.currentValue?.messages; track msg; let i = $index) {
              <mat-card
                class="message-card"
                [class.selected]="selectedItems[i]"
                [class.user-message]="msg.author === 'user'"
                [class.assistant-message]="msg.author === 'assistant'"
                (click)="toggleMessageSelection(i)"
              >
                <mat-card-content>
                  <div class="message-header">
                    <mat-checkbox
                      [(ngModel)]="selectedItems[i]"
                      (change)="toggleSelection(i, $event)"
                      (click)="$event.stopPropagation()"
                      class="message-checkbox"
                    ></mat-checkbox>
                    <span class="message-author">{{
                      msg.author === 'user' ? 'You' : getBotName()
                    }}</span>
                    <span class="message-date">{{ msg.date | date: 'short' }}</span>
                  </div>
                  <div class="message-preview">
                    {{ getMessagePreview(msg) }}
                  </div>
                </mat-card-content>
              </mat-card>
            }
          }

          @if (exportMode === 'tables') {
            @for (table of tableItems; track table.id) {
              <mat-card
                class="message-card"
                [class.selected]="selectedTables[table.id]"
                (click)="toggleTableSelection(table.id)"
              >
                <mat-card-content>
                  <div class="message-header">
                    <mat-checkbox
                      [(ngModel)]="selectedTables[table.id]"
                      (change)="toggleTableSelectionByCheckbox(table.id, $event)"
                      (click)="$event.stopPropagation()"
                      class="message-checkbox"
                    ></mat-checkbox>
                    <span class="message-author">{{ table.label }}</span>
                  </div>
                  <div class="message-preview">{{ table.rowCount }} rows</div>
                </mat-card-content>
              </mat-card>
            }
          }
        </div>
      </div>

      <!-- Preview Section (50%) - RIGHT -->
      <div class="preview-section">
        @if (exportMode === 'messages') {
          @if (countSelectedItems() === 0) {
            <div class="no-selection">
              <mat-icon>preview</mat-icon>
              <p>Select messages to see preview</p>
            </div>
          }

          @if (countSelectedItems() > 0) {
            <div class="preview-content">
              <div class="preview-display">
                @for (message of getSelectedMessages(); track message) {
                  <div
                    class="preview-message"
                    [class.user-message]="message.author === 'user'"
                    [class.assistant-message]="message.author === 'assistant'"
                  >
                    <div class="preview-text">
                      @for (paragraph of message.paragraphs; track paragraph; let i = $index) {
                        <span
                          [innerHTML]="
                            paragraph.text
                              | markdown: { mermaid: true, disableSanitizer: true }
                              | async
                          "
                        ></span>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }

        @if (exportMode === 'tables') {
          @if (countSelectedTables() === 0) {
            <div class="no-selection">
              <mat-icon>table_chart</mat-icon>
              <p>Select tables to see preview</p>
            </div>
          }

          @if (countSelectedTables() > 0) {
            <div class="preview-content">
              <div class="preview-display">
                @for (table of getSelectedTables(); track table.id) {
                  <div class="preview-message">
                    <div class="preview-text">
                      <strong>{{ table.label }}</strong>
                      <div>{{ table.rowCount }} rows</div>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>
    </div>
  </div>

  <!-- Bottom Sheet -->
  <div class="modal-footer">
    <div class="footer-actions">
      <!-- Export Options - Left Side -->
      <div class="export-options">
        @if (exportMode === 'messages') {
          <mat-checkbox [(ngModel)]="includeRefs" class="option-checkbox">
            Include references
          </mat-checkbox>
          <mat-checkbox [(ngModel)]="preserveFormatting" class="option-checkbox">
            Preserve formatting
          </mat-checkbox>
        }
      </div>

      <!-- Action Buttons - Right Side -->
      <div class="action-buttons">
        <button mat-button (click)="cancel()" class="cancel-btn">Cancel</button>
        @if (exportMode === 'messages') {
          <button
            mat-raised-button
            color="accent"
            [disabled]="!isValid()"
            [matMenuTriggerFor]="exportMenu"
            class="export-btn"
          >
            <mat-icon>output</mat-icon>
            Export
          </button>

          <mat-menu #exportMenu="matMenu">
            @for (driver of ExportFilesFactory.drivers; track driver) {
              <button mat-menu-item (click)="exportAs(driver.slug)">
                <mat-icon>{{ driver.icon }}</mat-icon>
                <span>Export as {{ getDriverDisplayName(driver.slug) }}</span>
              </button>
            }
          </mat-menu>
        }

        @if (exportMode === 'tables') {
          <button
            mat-raised-button
            color="accent"
            [disabled]="!isValid()"
            (click)="exportTables()"
            class="export-btn"
          >
            <mat-icon>table_view</mat-icon>
            Export CSV
          </button>
        }
      </div>
    </div>
  </div>
</div>
